import { AbstractDTO } from './abstract';
import { IPageBanner } from '@signature-it/ngx-generic/interfaces';

export class PageBannerDTO extends AbstractDTO implements IPageBanner {
    img: string;
    title: string;
    description: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.img = attributes['img'] || '';
        this.title = attributes['title'] || '';
        this.description = attributes['description'] || '';
    }

}
